<template>
  <table class="table table-bordered table-sm">
    <tr v-for="(l, i) in list" :key="i">
      <td class="w-100">{{ l.observation }}</td>
      <td class="text-right text-nowrap">{{ l.quantity | money }}</td>
      <td v-if="!disabled" class="p-0">
        <button class="btn btn-light btn-sm" @click="$emit('deleteItem', l.id)">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
    <tr>
      <th>TOTAL</th>
      <th class="text-right text-nowrap">{{ total | money }}</th>
    </tr>
  </table>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    list: {
      default: () => []
    },
    disabled: {
      default: false
    }
  },

  data: () => ({
    //
  }),

  computed: {
    total() {
      return this.list
        .map((x) => parseFloat(x.quantity))
        .reduce((p, c) => p + c, 0);
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style scoped></style>
